import { FilterHandlerBase } from './base/filter-handler-base';
import {
  AdvancedFilterName,
  FilterOptions,
  FilterPassParams,
  InclusiveExclusiveFilterModel
} from '../filter-types';
import { FilterResultFacade } from '../filter-result-facade';
import { Departement } from '../../../types/deal.types';
import { OptionsType } from '../../issue/maturity';

export class FinancialAdvisorAdvancedFilterHandler extends FilterHandlerBase {
  get name(): string {
    return AdvancedFilterName.financialAdvisor;
  }

  get isInclusiveExclusive(): boolean {
    return true;
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return filterOptions.financialAdvisors;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const financialAdvisor = params.filters[this.name];
    const data = params.deal;
    const isFinancialAdvisorFilterPassed: boolean = financialAdvisor
      ? ((financialAdvisor.model as InclusiveExclusiveFilterModel)
          .values as string[]).some((filter: string) =>
          data.financialAdvisors.length
            ? data.financialAdvisors.some(
                (value: Departement) => value.name && value.name === filter
              )
            : filter === OptionsType.Blank
        )
      : true;

    result.applyDealFilerResult(
      data.id,
      this.name,
      isFinancialAdvisorFilterPassed
    );
    return isFinancialAdvisorFilterPassed;
  }
}
